import { Pipe, PipeTransform } from '@angular/core';
import { positiveOrZero } from "../helpers";

@Pipe({
    name: "positiveOrZero",
    standalone: false
})

export class PositiveOrZeroPipe implements PipeTransform {
  transform(value: number) {
    return positiveOrZero(value)
  }
}
